// extracted by mini-css-extract-plugin
export var btn = "main-module--btn--51e51";
export var btnOrange = "main-module--btn-orange--f00ce";
export var centeredBtnBlock = "main-module--centered-btn-block--70f83";
export var container = "main-module--container--02c82";
export var hugs = "main-module--hugs--3c772";
export var listTriple = "main-module--list-triple--0c11d";
export var orange = "main-module--orange--8c62f";
export var shadow = "main-module--shadow--97a68";
export var title = "main-module--title--98e66";
export var violet = "main-module--violet--e7cf4";